import React, { useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import { DateTime } from 'luxon';
import { useTranslation } from 'react-i18next';

import computePreparationTime from '../../../../actions/orders/helpers/computePreparationTime';
import { computeEstimatedTime } from '../../../../actions/orders/helpers/computeTimesHelpers';
import { Button } from '../../../../styleguide';
import { PrintIcon } from '../../../../styleguide/icons';
import { SPACING } from '../../../../styles/constants';
import { ClientReceipt } from '../../../shop/orders/receipts';

const DownloadReceiptButton = props => {
  const { order } = props;
  const { t } = useTranslation(['orders']);
  const clientRef = useRef(null);

  const handlePrint = useReactToPrint({
    content: () => clientRef.current,
    onPrintError: all => console.error({ all }),
  });

  const orderAt = DateTime.fromMillis(order.orderAt).toLocaleString(
    DateTime.DATETIME_SHORT
  );
  const estimatedDeliveryTime = computeEstimatedTime({
    ts: order.orderAt,
    withDelay: false,
    minutes:
      order.estimatedTimeToDeliver || computePreparationTime(order.itemsList),
    seconds: order.duration,
  });

  return (
    <>
      <Button
        small
        startIcon={<PrintIcon size="16px" />}
        onClick={handlePrint}
        styles={{ marginTop: SPACING[200] }}
      >
        {t('orders:tracking:download_receipt')}
      </Button>
      <div style={{ display: 'none' }}>
        <ClientReceipt
          ref={clientRef}
          order={order}
          orderAt={orderAt}
          estimatedDeliveryTime={estimatedDeliveryTime}
        />
      </div>
    </>
  );
};

export default DownloadReceiptButton;
